export default "skymp5-front/19bf86bbf52f8a7b56d3ac6e823f9217.png";